/* ES Design — Scroll Animation Controller
   Loads once, observes [data-reveal] elements, triggers reveals on view.
   Handles [data-parallax] with rAF for smooth performance.
*/
(function() {
  'use strict';
  if (window.__esScrollLoaded) return;
  window.__esScrollLoaded = true;

  // Respect user preferences
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 750px)').matches;

  // === Intersection Observer for reveals ===
  function setupReveal() {
    if (reducedMotion) {
      document.querySelectorAll('[data-reveal], [data-stagger]').forEach(function(el){
        el.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // No support: show everything immediately
      document.querySelectorAll('[data-reveal], [data-stagger]').forEach(function(el){
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Once revealed, stop observing (perf)
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -80px 0px'
    });

    document.querySelectorAll('[data-reveal], [data-stagger]').forEach(function(el){
      observer.observe(el);
    });
  }

  // === Parallax with rAF ===
  function setupParallax() {
    if (reducedMotion || isMobile) return;

    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!elements.length) return;

    var raf = null;
    function update() {
      var viewportHeight = window.innerHeight;
      var scrollY = window.scrollY;
      elements.forEach(function(el) {
        var factor = parseFloat(el.getAttribute('data-parallax')) || 0.3;
        var rect = el.getBoundingClientRect();
        // Only calc if in view
        if (rect.bottom < 0 || rect.top > viewportHeight) return;
        var elCenter = rect.top + rect.height / 2;
        var viewportCenter = viewportHeight / 2;
        var offset = (elCenter - viewportCenter) * factor * -1;
        el.style.setProperty('--es-parallax-y', offset + 'px');
      });
      raf = null;
    }
    function onScroll() {
      if (raf === null) {
        raf = requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // === Init on DOM ready ===
  function init() {
    setupReveal();
    setupParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-init on Shopify Section Editor changes (for live theme editor preview)
  document.addEventListener('shopify:section:load', setupReveal);
  document.addEventListener('shopify:section:reorder', setupReveal);
})();
